import type React from 'react';
import { IntlProvider } from 'react-intl';
import type { PropsWithChildren } from 'react';
import { useTypedSelector } from '../../Store/connectors';

const WithLocaleProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const language = useTypedSelector(
        ({ metaData }) => metaData.locale,
    );
    return (
        <IntlProvider locale={language}>
            {children}
        </IntlProvider>
    );
};

export default WithLocaleProvider;
